import { isArray } from 'lodash-es'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { CompanyContext } from '../../contexts'

export default function Form({ id, onSubmit }) {
  const { company_types } = useContext(CompanyContext)
  const [aliases, setAliases] = useState([{ name: '' }])
  const {
    createdSuccessModalVisibility,
    errorsFromServer: { new: serverErrors },
  } = useSelector((state) => state.company)

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm()

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors).forEach((field) => {
        setError(field, {
          type: 'server',
          message: isArray(serverErrors[field]) ? serverErrors[field].join(', ') : serverErrors[field],
        })
      })
    }
  }, [serverErrors, setError])

  useEffect(() => {
    if (!createdSuccessModalVisibility) return

    setAliases([{ name: '' }])
    reset()
  }, [createdSuccessModalVisibility])

  const addAlias = () => {
    setAliases([...aliases, { name: '' }])
  }

  const removeAlias = (index) => {
    setAliases(aliases.filter((_, i) => i !== index))
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} id={id}>
        <div className="form-group">
          <label className="form-label" htmlFor="company_name">
            name
          </label>
          <input
            type="text"
            {...register('name', { required: 'name is required.' })}
            className="form-control dome-input"
            id="company_name"
          ></input>
          {errors.name && <p style={{ color: 'red' }}>{errors.name.message}</p>}
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="company_type">
            company type
          </label>
          <select {...register('company_type')} className="form-control dome-input" id="company_type">
            {company_types.map(([value, label], key) => (
              <option key={key} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="col-form-label" htmlFor="company_logo">
            upload logo
          </label>
          <input type="file" className="form-control dome-input" {...register('company_logo')}></input>
        </div>
        <p className="dome-p2" style={{ fontWeight: '700' }}>
          Aliases
        </p>
        <p className="dome-p3-lt">
          Please note that there is always an alias with the same name as the official name mentioned above.
        </p>
        {aliases.map((alias, index) => (
          <div className="form-group" key={index}>
            <label className="form-label" htmlFor={`alias_name_${index}`}>
              {`alias name #${index + 1}`}
            </label>
            <div className="dome-d-flex dome-gap6 dome-align-center">
              <input
                {...register(`company_aliases_attributes[${index}].name`)}
                className="form-control dome-input"
                id={`alias_name_${index}`}
              ></input>
              <i
                className="fa-thin fa-square-minus dome-color-med-grey"
                style={{ fontSize: 'xx-large' }}
                role="button"
                onClick={() => removeAlias(index)}
              ></i>
            </div>
            {errors?.company_aliases_attributes?.[index]?.name && (
              <p style={{ color: 'red' }}>{errors.company_aliases_attributes[index].name.message}</p>
            )}
          </div>
        ))}
        <i
          className="fa-thin fa-square-plus dome-color-aqua"
          style={{ fontSize: 'xx-large' }}
          role="button"
          onClick={addAlias}
        ></i>
      </form>
    </>
  )
}
